<div class="billing__info__page mb-5">
  <div class="row my-4">
    <div class="col-md-1 align-self-center">
      <button id="billing-back-button" type="button" class="button ghost__button icon__left p-0"
              (click)="goBack()">
        <em class="fa fa-arrow-left"></em>
        Back
      </button>
    </div>
    <div class="col-md-7">
      <div class="title">Transactions history</div>
    </div>
    <!-- <div class="col-md-4 text-right">
        <button id="save-all-changes" type="button" [routerLink]="['/payment/pricing']" class="button primary__button large__button">
            See pricing options
        </button>
    </div> -->
  </div>

  <div class="row mt-4">
    <!-- <div class="col-md-4 left__box">
        <h4 class="font-weight-bold mb-0">You have
            <span class="color--blue">
                {{userService.getUserCredits()}} {{userService.getUserCredits() > 1 ? 'Credits Left' : 'Credit
                Left'}}
            </span>
        </h4>
        <small class="color--light--gray" *ngIf="false">Professional expired at 12/24/2021</small>

        <div class="row">
            <div class="col-md-12 credit__info">
                Credit is the unit in the system that can be used for 2 options:
                <ul>
                    <li>get the final value for a new report</li>
                    <li>edit the existing report (you have opportunity to edit your report for free for 3 days after
                        getting final valuation</li>
                </ul>
                Buy many credits at once, no worries, they are valid forever.
            </div>
            <div class="com-md-12 w-100 mt-3 px-4">
                <button id="buy-more-credits" type="button" class="button primary__button w-100" (click)="openCreditPurchasePopup()">
                    Buy more credits
                </button>
                <button id="see-other-pricing-options" type="button" class="button secondary__button w-100 mt-3" (click)="gotoPricingPage()">
                    See other pricing options
                </button>
                <button id="cancel-subscription" type="button" class="button cancel__sub__button w-100 mt-3"
                    *ngIf="false">
                    Cancel subscription
                </button>
            </div>
        </div>
    </div> -->

    <div class="col-md-12 transactions__history">

      <div class="row table__header">
        <div class="col-md-3">Amount</div>
        <div class="col-md-3">Action</div>
        <div class="col-md-3">Status</div>
        <div class="col-md-3">Date</div>
      </div>
      <div class="row table__row" *ngFor="let tran of transactionHistory; let i = index;">
        <div class="col-md-3">{{ tran.AMOUNT }} {{ reportService.changeTextStyle(tran.TYPE) }}</div>
        <div class="col-md-3">{{ reportService.changeTextStyle(tran.ACTION) }}</div>
        <div class="col-md-3">{{ reportService.changeTextStyle(tran.STATUS) }}</div>
        <div class="col-md-3">{{ tran.DATE | date: 'MM/dd/yyyy' }}</div>
      </div>

      <div *ngIf="totalRecords > 10" class="pagination-wrapper">
        <pagination [totalItems]="totalRecords" class="valzy__pagination"
                    previousText="&lsaquo;" nextText="&rsaquo;"
                    (pageChanged)="pageChanged($event)" [itemsPerPage]="10" [maxSize]="5"></pagination>
      </div>

    </div>
  </div>
</div>
